var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { connect } from 'react-redux';
import { Modal } from 'semantic-ui-react';
import Button from 'components/Button/Button';
import { beginTermination } from 'app/actions/sandboxItemActions';
import { closeModal } from '../../actions/modalActions';
var TerminateModal = /** @class */ (function (_super) {
    __extends(TerminateModal, _super);
    function TerminateModal(props) {
        var _this = _super.call(this, props) || this;
        _this.handleTermination = _this.handleTermination.bind(_this);
        return _this;
    }
    TerminateModal.prototype.componentDidMount = function () {
        var sandboxData = this.props.sandboxData;
        window.neo4jSandbox.analytics.lastTerminatePopup = {
            seenAt: Date.now(),
            usecase: sandboxData.usecase,
        };
    };
    TerminateModal.prototype.handleTermination = function () {
        var _a = this.props, user = _a.user, sandboxData = _a.sandboxData, onActionConfirm = _a.onActionConfirm, onTerminateConfirm = _a.onTerminateConfirm;
        onTerminateConfirm(user.accessToken, sandboxData);
        onActionConfirm();
    };
    TerminateModal.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, open = _a.open;
        return (React.createElement(Modal, { open: open, onClose: onClose, closeIcon: true },
            React.createElement(Modal.Header, null, "Are you sure?"),
            React.createElement(Modal.Content, null,
                React.createElement("p", null, "Terminating the sandbox will delete all the data.")),
            React.createElement(Modal.Actions, null,
                React.createElement(Button, { onClick: onClose }, "Cancel"),
                React.createElement(Button, { color: "pink", onClick: this.handleTermination }, "Terminate"))));
    };
    return TerminateModal;
}(React.Component));
export { TerminateModal };
var mapDispatchToProps = function (dispatch) { return ({
    onTerminateConfirm: function (accessToken, data) { return dispatch(beginTermination(accessToken, data)); },
    onActionConfirm: function () { return dispatch(closeModal()); },
}); };
var mapStateToProps = function (state) { return ({
    terminateSandboxHashKey: state.activeModal.data.terminateSandboxHashKey,
    user: state.user,
    sandboxData: state.activeModal.data,
}); };
export default connect(mapStateToProps, mapDispatchToProps)(TerminateModal);
